import { withStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { isCurrentSeasonFresh, resolveCurrentSeason } from '../../config/currentSeason'
import AppBar from './appBar'
import Layout from './layout'
import Menu from './menu'

//import MyMenu from './MyMenu';
//import MyNotification from './MyNotification';

const ContainerStyled = styled.div`
  & > div {
    padding-top: ${(props) => props.height};
    transition: padding-top 0.3s;
  }
`
const styles = (theme) => {
  return {
    layout: {
      backgroundColor: theme.palette.grey[200],
    },
  }
}

const MyLayout = (props) => {
  const height = props.subheader ? '50px' : '0px'

  // Los filtros por defecto de los listados leen la temporada en curso de forma
  // síncrona, así que no pintamos hasta tenerla resuelta al menos una vez hoy.
  const [seasonReady, setSeasonReady] = useState(isCurrentSeasonFresh())
  useEffect(() => {
    resolveCurrentSeason().then(() => setSeasonReady(true))
  }, [])

  if (!seasonReady) return null

  return (
    <ContainerStyled height={height}>
      <Layout {...props} className={props.classes.layout} appBar={AppBar} menu={Menu} />
    </ContainerStyled>
  )
}

export default withStyles(styles)(MyLayout)
